var _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneCheckmarksWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1090_8063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 37,
    height: 37
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6367,
    width: 36.3636,
    height: 36.3636,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1090_8063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.426 9.46906L28.5244 23.3706L25.2858 20.1319L23.1777 22.342L28.5244 27.6888L44.585 11.6281L42.426 9.46906Z",
    fill: "#FDFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1090_8063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.3636,
    height: 36.3636,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1090_8063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4703 27.2728L5.83398 18.6364L7.99308 16.4773L14.4703 22.9546L28.3719 9.0531L30.531 11.2122L14.4703 27.2728Z",
    fill: "#FDFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCheckmarksWide);
export default __webpack_public_path__ + "static/media/done-checkmarks-wide.cb45fa99e20ca08930cab2938dd6bcaf.svg";
export { ForwardRef as ReactComponent };